<div id="sidebar">
  <mat-nav-list>
    <a
      mat-list-item
      [routerLinkActive]="'active'"
      routerLink="/admin/dashboard"
      *ngIf="checkRoles('/admin/users')"
    >
      <mat-icon class="sidenav-icon">dashboard</mat-icon>
      {{ 'NAVIGATION.ANALYTICS' | translate }}
    </a>
    <ng-container *ngIf="checkRoles('/admin/users')">
      <mat-accordion class="sidebar-dropdown">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="sidenav-icon">account_box</mat-icon>
              {{ 'NAVIGATION.ADMINISTRATION' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/users"
          >
            <mat-icon class="sidenav-icon">account_box</mat-icon>
            {{ 'NAVIGATION.USERS' | translate }}
          </a>
          <a
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/user-roles"
          >
            <mat-icon class="sidenav-icon">account_box</mat-icon>
            {{ 'NAVIGATION.USER_ROLES' | translate }}
          </a>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

    <a
      mat-list-item
      [routerLinkActive]="'active'"
      routerLink="/admin/companies"
      *ngIf="checkRoles('/admin/companies')"
    >
      <mat-icon class="sidenav-icon">home_work</mat-icon>
      {{ 'NAVIGATION.COMPANIES' | translate }}
    </a>

    <a
      mat-list-item
      [routerLinkActive]="'active'"
      *ngIf="checkRoles('/admin/branches')"
      routerLink="/admin/branches"
    >
      <mat-icon class="sidenav-icon">device_hub</mat-icon>
      {{ 'NAVIGATION.LOCATIONS' | translate }}
    </a>
    <ng-container
      *ngIf="checkRoles('/admin/cities') || checkRoles('/admin/countries')"
    >
      <mat-accordion class="sidebar-dropdown">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="sidenav-icon">apartment</mat-icon>
              {{ 'NAVIGATION.GEO_LOCATIONS' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/countries"
            *ngIf="checkRoles('/admin/countries')"
          >
            <mat-icon class="sidenav-icon">apartment</mat-icon>
            {{ 'NAVIGATION.COUNTRIES' | translate }}
          </a>
          <a
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/cities"
            *ngIf="checkRoles('/admin/cities')"
          >
            <mat-icon class="sidenav-icon">apartment</mat-icon>
            {{ 'NAVIGATION.CITIES' | translate }}
          </a>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    <ng-container
      *ngIf="
        checkRoles('/admin/campaigns') ||
        checkRoles('/admin/advertisements') ||
        checkRoles('/admin/tags')
      "
    >
      <mat-accordion class="sidebar-dropdown">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="sidenav-icon">style</mat-icon>
              {{ 'NAVIGATION.ADVERTISING' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a
            *ngIf="checkRoles('/admin/campaigns')"
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/campaigns"
          >
            <mat-icon class="sidenav-icon">style</mat-icon>
            {{ 'NAVIGATION.CAMPAIGNS' | translate }}
          </a>
          <a
            *ngIf="checkRoles('/admin/advertisements')"
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/advertisements"
          >
            <mat-icon class="sidenav-icon">style</mat-icon>
            {{ 'NAVIGATION.ADVERTISEMENTS' | translate }}
          </a>
          <a
            *ngIf="checkRoles('/admin/tags')"
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/tags"
          >
            <mat-icon class="sidenav-icon">tag</mat-icon>
            {{ 'NAVIGATION.CATEGORIES' | translate }}
          </a>
          <a
            *ngIf="checkRoles('/admin/branding-buttons')"
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/branding-buttons"
          >
            <mat-icon class="sidenav-icon">collections</mat-icon>
            {{ 'NAVIGATION.BRANDING_BUTTON' | translate }}
          </a>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    <ng-container
      *ngIf="checkRoles('/admin/routers')"
    >
      <mat-accordion class="sidebar-dropdown">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="sidenav-icon">routers</mat-icon>
              {{ 'NAVIGATION.ROUTERS' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/routers"
          >
            <mat-icon class="sidenav-icon">list</mat-icon>
            {{ 'NAVIGATION.LIST' | translate }}
          </a>
          <a
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/routers/analytics"
          >
            <mat-icon class="sidenav-icon">analytics</mat-icon>
            {{ 'NAVIGATION.VIEW_STATISTICS' | translate }}
          </a>
          <a
            mat-list-item
            [routerLinkActive]="'active'"
            routerLink="/admin/routers/overall-analytics"
          >
            <mat-icon class="sidenav-icon">analytics</mat-icon>
            {{ 'NAVIGATION.TOTAL_STATISTICS' | translate }}
          </a>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    <!-- <ng-container>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Test dropdown
            </mat-panel-title>
          </mat-expansion-panel-header>
          x
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container> -->
  </mat-nav-list>
</div>
